module.exports = __webpack_public_path__ + "static/media/fysical.bfbdec11.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/fysical.png
// module id = 1864
// module chunks = 146